import type { ReactNode } from "react";

/**
 * Status tones. Semantic names are preferred for new code; the older color
 * names stay valid (green = good, orange = warn, sand = neutral-warm,
 * blue = info) so existing screens keep working.
 */
export type BadgeTone =
  | "neutral"
  | "good"
  | "warn"
  | "danger"
  | "info"
  | "loss"
  | "gain"
  | "unknown"
  | "green"
  | "orange"
  | "sand"
  | "blue"
  | "hero";

export function Badge({
  children,
  tone = "neutral",
  dot = false,
  title,
}: {
  children: ReactNode;
  tone?: BadgeTone | string;
  /** A small leading dot, for status lists where the word alone is short. */
  dot?: boolean;
  title?: string;
}) {
  return (
    <span className={`badge ${tone || "neutral"}${dot ? " with-dot" : ""}`} title={title}>
      {dot && <i aria-hidden="true" className="badge-dot" />}
      {children}
    </span>
  );
}
